/** @deprecated - this is moved to libs */
export enum MyZoneRoutes {
    MyInsurances = 'mijn-verzekeringen',
    Details = 'mijn-gegevens',
    Damages = 'mijn-schades',
}
